import React, { useEffect, useState, useRef } from "react";
import "./CashierFraud.css";
import "./CashierFraudUpdated.css"; // this file contains ReportsUpdated.css content
import RadioButton from "./RadioButtonCashierSection.tsx";
import FilterModal from "./FilterModal.tsx";
import { Divider, Tooltip } from "@mui/material";
import axios from "axios";
import moment from "moment";
import { Dialog } from "primereact/dialog";
import CashierFraudInnerSkeleton from "./CashierFraudInnerSkeleton.tsx";
// import CashierFraudInnerSkeletonMobile from './CashierFraudInnerSkeletonMobile.tsx';
import { useNavigate } from "react-router-dom";
import { toast } from "../../components/Toast/toast.ts";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CustomVideoPlayer from "../../components/CustomVideoPlayer/CustomVideoPlayerWithPrevNextBtn.tsx";
import CustomImage from "../../components/CustomImg/CustomImage.tsx";
import PaidIcon from "@mui/icons-material/Paid";
import { useMediaQuery } from "@mui/material";
import { ProgressSpinner } from "primereact/progressspinner";
import { useUserContext } from "../../../src/context/UserContext.tsx";
import SearchBar from "./SearchBar.tsx";
import Drawer from "./ReportsDrawer.tsx";
import { DataTable } from "../../components/DataTable/index.ts";
import type { Column } from "../../components/DataTable/index.ts";
import { StatusChip } from "../../components/StatusChip/index.ts";
import DescriptionBox from "../../components/DescriptionBox/index.tsx";
import VideoDialog from "../../components/VideoDialog/VideoDialog.tsx";
import VideoSidebar from "../../components/VideoDialog/VideoSidebar.tsx";

const CashierFraudUpdated = () => {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState("");
  const [visible, setVisible] = React.useState(false);
  const [imgvisible, setimgVisible] = React.useState(false);
  const [filterVal, setFilterVal] = React.useState(false);
  const [videoHeader, setVideoHeader] = React.useState("");
  const [imgHeader, setimgHeader] = React.useState("");
  const [video, setVideo] = React.useState("");
  const [Image, setImage] = React.useState("");
  const storedToken = localStorage.getItem("token");
  const [loading, setLoading] = React.useState(false);
  const [category, setSelectedCategory] = React.useState("all");
  const [currentCount, setCurrentCount] = React.useState(10);
  const [currentVideoIndex, setCurrentVideoIndex] = React.useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isAllDataFetched, setIsAllDataFetched] = React.useState(false);
  const [Data, setData] = React.useState([]);
  const [todate, setTodate] = React.useState(null);
  const [fromdate, setFromdate] = React.useState(null);
  const [searchVal, setSearchVal] = React.useState("");
  //  const [status, setStatus] = React.useState("")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [innerLoading, setInnerLoading] = React.useState(false);
  // const [storevalue, setStoreValue] = React.useState('');
  const [openDrawer, setOpenDrawer] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMobile = useMediaQuery("(max-width:1200px)");
  const isMediumScreen = useMediaQuery(
    "(min-width:800px) and (max-width:1200px)",
  );
  const { globalstorevalue } = useUserContext();

  // to send to GA4 for analytics
  const [currentStoreName, setCurrentStoreName] = useState("");

  const navigate = useNavigate();

  const normalizedData = (Data || []).flatMap((item: any) =>
    (item?.media || [])
      .filter((m: any) => m?.file_url && m?.poster_url)
      .map((m: any) => ({
        ...item,
        video_link: m.file_url,
        poster_url: m.poster_url,
        store_name: item.store_id?.name || "Unknown Store",
        reason: m?.file_name || "",
      })),
  );

  const cashierColumns: Column[] = [
    {
      key: "store_id.name",
      label: "Store",
      width: "22%",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: 500 }}>{row?.store_id?.name}</span>
            <span className="text-caption">{row?.store_id?.city}</span>
          </div>
        </div>
      ),
    },
    {
      key: "cashier_status",
      label: "Status",
      width: "15%",
      render: (value) => {
        const formatted = formatString(value);
        let variant: "success" | "warning" | "danger" | "info" | "neutral" = "neutral";
        const lower = (formatted || "").toLowerCase();
        if (lower.includes("fraud")) variant = "danger";
        else if (lower.includes("suspicious")) variant = "warning";
        else if (lower.includes("pending")) variant = "info";
        else if (lower.includes("email sent")) variant = "info";
        else if (lower.includes("resolved") || lower.includes("verified")) variant = "success";
        return <StatusChip label={formatted || "N/A"} variant={variant} />;
      },
    },
    {
      key: "report_date",
      label: "Date",
      width: "12%",
      render: (value) => (
        <span className="table-cell-secondary">{formatDate(value)}</span>
      ),
    },
    {
      key: "report",
      label: "Details",
      width: "30%",
      fullWidthOnMobile: true,
      render: (value) => (
        <span className="table-cell-secondary" style={{ lineHeight: "1.4" }}>
          {value?.length > 120 ? value.substring(0, 120) + "..." : value}
        </span>
      ),
    },
    {
      key: "media",
      label: "Media",
      width: "21%",
      align: "center",
      render: (value, row, index) => {
        if (!value || value.length === 0) {
          return (
            <div className="text-caption flex justify-center">No media</div>
          );
        }
        const images = value.filter((el: any) =>
          el?.file_name?.match(/\.(bmp|jpg|png|webp)$/),
        );
        const videos = value.filter((el: any) =>
          el?.file_name?.match(/\.(mp4|avi)$/),
        );
        return (
          <div className="flex gap-1.5 items-center justify-center flex-wrap">
            {images.map((element: any, i: number) => (
              <Tooltip key={`img-${i}`} title="Click to View Full Size Image">
                <div
                  className="report-media-img max-w-[60px] max-h-[45px] overflow-hidden rounded"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleImageOpen(row, element);
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "5px",
                      objectFit: "cover",
                    }}
                    src={element?.file_url}
                    alt=""
                  />
                </div>
              </Tooltip>
            ))}
            {videos.map((element: any, i: number) => (
              <Tooltip key={`vid-${i}`} title="Click to Play Video">
                <div
                  className="report-media-img max-w-[60px] max-h-[45px] overflow-hidden rounded relative"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenDialog(row, index);
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "5px",
                      objectFit: "cover",
                    }}
                    src={element?.poster_url}
                    alt=""
                  />
                  <span id="playIconDiv">
                    <PlayCircleIcon sx={{ color: "black", fontSize: "25px" }} />
                  </span>
                </div>
              </Tooltip>
            ))}
          </div>
        );
      },
    },
  ];

  const formatDate = (dateString) => {
    // return moment(dateString).format('DD/MM/YYYY');
    let date = dateString.substring(0, 10);
    return moment(date).format("DD-MM-YYYY");
  };
  const formatString = (str) => {
    const words = str?.split(/(?=[A-Z])/);
    const capitalizedWords = words?.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1),
    );
    return capitalizedWords?.join(" ");
  };

  const fetchCashierReports = async () => {
    if (storedToken) {
      // console.log("currentCount:", currentCount)
      try {
        setLoading(true);
        let response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/cust-portal/native/cashier-fraud?category=${category}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          },
        );
        setData(response?.data?.reports);
        // console.log(category, ":", response?.data?.reports);
        if (response?.data?.reports.length < 10) {
          setIsAllDataFetched(true);
        }
        setLoading(false);
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            error?.message ||
            "An error occurred. Please try again.",
        );
        setLoading(false);
      }
    }
  };

  const fetchfilteredData = async () => {
    try {
      setIsAllDataFetched(false);
      setFilterVal(true);
      setCurrentCount(10);
      if (storedToken) {
        setLoading(true);
        const filterUrl = `${process.env.REACT_APP_API_URL}/api/cust-portal/native/cashier-fraud?category=${category}${fromdate ? `&rangeDates=${fromdate}` : ""}${todate ? `&rangeDates=${todate}` : ""}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}${searchVal ? `&search=${searchVal}` : ""}`;
        const response = await axios.get(filterUrl, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setData(response?.data?.reports);
        //   console.log(category, response?.data?.reports?.length)
        if (response?.data?.reports.length < 10) {
          setIsAllDataFetched(true);
          //setFilterVal(false)
        }
        setLoading(false);
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to retrieve reports data!",
      );
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (filterVal) {
      fetchfilteredData();
    } else {
      fetchCashierReports();
    }
    // eslint-disable-next-line
  }, [category, globalstorevalue]);

  const fetchMoreData = async () => {
    if (isAllDataFetched) return;

    const storedToken = localStorage.getItem("token");

    const newRows = currentCount + 20;
    setInnerLoading(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cust-portal/native/cashier-fraud?first=0&rows=${newRows}&category=${category}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        },
      );
      const newData = response?.data?.reports || [];
      // console.log(0, newRows)
      // console.log("newData with", category, ":", newData)

      if (newData?.length < newRows) {
        setIsAllDataFetched(true);
        //setCurrentCount(10)
      }
      setData(newData);
      setCurrentCount(newRows);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "An error occurred. Please try again.",
      );
    } finally {
      setInnerLoading(false);
    }
  };

  const filterMoreData = async () => {
    if (isAllDataFetched) return;

    const storedToken = localStorage.getItem("token");

    const newRows = currentCount + 20;
    setInnerLoading(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cust-portal/native/cashier-fraud?first=0&rows=${newRows}${fromdate ? `&rangeDates=${fromdate}` : ""}${todate ? `&rangeDates=${todate}` : ""}${globalstorevalue ? `&stores=${globalstorevalue}` : ""}&category=${category}${searchVal ? `&search=${searchVal}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        },
      );
      const newData = response?.data?.reports || [];
      // console.log(0, newRows)
      // console.log("newData with", category, ":", newData.length)

      if (newData?.length < newRows) {
        setIsAllDataFetched(true);
        //setCurrentCount(10)
      }
      setData(newData);
      setCurrentCount(newRows);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "An error occurred. Please try again.",
      );
    } finally {
      setInnerLoading(false);
    }
  };

  const handleImageOpen = (item, element) => {
    setCurrentStoreName(item.store_id?.name);
    setimgHeader(element.file_name);
    setImage(element.file_url);
    setimgVisible(true);
  };

  useEffect(() => {
    if (!visible || !currentStoreName) return;

    try {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "video_opened",
        videoHeader: videoHeader || "(unknown)",
        storeName: currentStoreName,
      });

      // Optional cleanup (not required, but OK since you already use this pattern)
      window.dataLayer.push({
        videoHeader: undefined,
        storeName: undefined,
      });
    } catch (error) {
      console.error("Error firing video_opened event:", error);
    }
  }, [visible, currentStoreName, videoHeader]);

  useEffect(() => {
    if (!imgvisible || !currentStoreName) return;

    try {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "image_opened",
        imageHeader: imgHeader || "(unknown)",
        storeName: currentStoreName,
      });

      // Optional cleanup
      window.dataLayer.push({
        imageHeader: undefined,
        storeName: undefined,
      });
    } catch (error) {
      console.error("Error firing image_opened event:", error);
    }
  }, [imgvisible, currentStoreName, imgHeader]);

  const handleClick = (id, store_name) => {
    try {
      if (!store_name) {
        console.warn("Store name is invalid or empty:", store_name);
        return; // Early exit if storeName is not valid
      }

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "store_interaction",
        storeName: store_name,
      });

      // Clear the store data to avoid carryover
      window.dataLayer.push({
        event: "clear_store_data",
        storeName: undefined,
      });

      navigate(`/report/${id}`);
    } catch (error) {
      console.error("Error handling store interaction in handleClick:", error);
    }
  };

  const handleOpenDialog = (rowData: any, rowIndex: number) => {
    try {
      const hasVideo = rowData?.media?.some((m: any) =>
        m?.file_name?.match(/\.(mp4|avi)$/) && m?.file_url && m?.poster_url
      );

      if (!hasVideo) {
        toast.error("No valid video file found.");
        return;
      }

      const flatIndex = normalizedData.findIndex(
        (n: any) => n._id === rowData._id
      );

      setCurrentVideoIndex(flatIndex !== -1 ? flatIndex : 0);
      setCurrentStoreName(rowData.store_id?.name || "");
      setVisible(true); // opens VideoDialog
    } catch (error) {
      toast.error("Failed to open video. Please try again.");
    }
  };

  const handleCloseDialog = () => {
    if (currentVideoIndex !== null && Data[currentVideoIndex]) {
      //  if (isButtonClicked) {
      const reportElement = document.getElementById(
        `report-${Data[currentVideoIndex]._id}`,
      );
      if (reportElement) {
        // Add a highlight class to the element
        reportElement.classList.add("highlight-row");

        // Scroll to the element
        reportElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        setTimeout(() => {
          reportElement?.classList.remove("highlight-row");
        }, 10000);
      }
      // }
    }
    setVisible(false); // Close the modal
    // setIsButtonClicked(false);
  };

  return (
    <>
      <div className="cashier-page-inner-container">
        <VideoDialog
          visible={visible}
          onHide={handleCloseDialog}
          data={normalizedData}
          currentIndex={currentVideoIndex}
          onIndexChange={(i) => setCurrentVideoIndex(i)}
          onLoadMore={fetchMoreData}
          isAllDataFetched={isAllDataFetched}
          defaultSidebarOpen={true}
          sidebarContent={(onSelect) => (
            <VideoSidebar
              data={normalizedData}
              currentIndex={currentVideoIndex}
              onSelect={(i) => {
                onSelect(i);
                setCurrentVideoIndex(i);
              }}
              onClose={handleCloseDialog}
              isAllDataFetched={isAllDataFetched}
              onLoadMore={fetchMoreData}
            />
          )}
        />
        <Dialog
          header={imgHeader}
          visible={imgvisible}
          maximized
          style={{ width: "100vw" }}
          breakpoints={{ "960px": "75vw", "641px": "100vw" }}
          onHide={() => setimgVisible(false)}
        >
          <div className="image-modal-container">
            {/* <img src={Image} alt="" style={{ width: "100%", height: "100%" }} /> */}
            <CustomImage src={Image} alt={imgHeader} imageName={imgHeader} />
          </div>
        </Dialog>
        <div id="cashierPageMainDiv">
          <DataTable
            columns={cashierColumns}
            data={Data}
            rowKey="_id"
            loading={loading}
            skeletonRows={8}
            onRowClick={(row) => handleClick(row?._id, row?.store_id?.name)}
            emptyMessage={
              category === "cashierFraud"
                ? "No Cashier Fraud Activity Found"
                : "No Cashier Activity Found."
            }
            maxHeight="calc(100vh - 280px)"
            onScrollEnd={filterVal ? filterMoreData : fetchMoreData}
            hasMore={!isAllDataFetched}
            loader={<CashierFraudInnerSkeleton />}
            endMessage={<span>No More Cashier Activity</span>}
            header={
              <div className="flex flex-wrap justify-between gap-4">
                <DescriptionBox
                  subTitle={
                    category === "cashierFraud"
                      ? "Cashier Fraud Reports"
                      : category === "cashierSuspicious"
                        ? "Cashier Suspicious Reports"
                        : "Cashier Reports"
                  }
                  title="POS Loss Prevention"
                  description="Detailed report of POS activities and cashier exception transactions."
                />

                <div id="cashier-fraud-page-heading-right-container">
                  <RadioButton
                    category={category}
                    setSelectedCategory={setSelectedCategory}
                    setCurrentCount={setCurrentCount}
                    setIsAllDataFetched={setIsAllDataFetched}
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <SearchBar
                      searchVal={searchVal}
                      setSearchVal={setSearchVal}
                      fetchfilteredData={fetchfilteredData}
                    />
                    <div>
                      <FilterModal
                        setData={setData}
                        setLoading={setLoading}
                        setIsAllDataFetched={setIsAllDataFetched}
                        setCurrentCount={setCurrentCount}
                        fetchCashierReports={fetchCashierReports}
                        setFilterVal={setFilterVal}
                        fromdate={fromdate}
                        setFromdate={setFromdate}
                        todate={todate}
                        setTodate={setTodate}
                        category={category}
                        fetchfilteredData={fetchfilteredData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </div>
      </div>
    </>
  );
};

export default CashierFraudUpdated;
